import { ApiListResponse, FacilityDTO, FacilityStatus } from "@gymflow/types";

import { createAxiosInstance } from "../createAxiosInstance";
import { createSortParam } from "../createSortParam";

export type PublicFacilityApiType = ReturnType<typeof publicFacilityApi>;

const publicFacilityApi = (apiUrl: string, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const axiosInstance = createAxiosInstance({
    apiUrl,
  });

  return {
    find({
      page = 0,
      limit = 10,
      extraParams = {},
      sort,
    }: {
      readonly extraParams?: {
        readonly status?: FacilityStatus;
        readonly [k: string]: any;
      };
      readonly page?: number;
      readonly limit?: number;
      readonly sort?: {
        readonly field: string;
        readonly desc: boolean;
      };
    }) {
      const config = {
        params: {
          page,
          size: limit,
          ...extraParams,
        },
      } as any;
      if (sort) {
        config.params.sort = createSortParam(sort);
      }

      return axiosInstance.get<ApiListResponse<FacilityDTO>>(
        `${clubPrefix}hosted/facility`,
        config,
      );
    },
  };
};

export default publicFacilityApi;
